module.exports = __webpack_public_path__ + "static/media/user-circle.acac3272.svg";